// Copyright 2018 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @module elements-sk/toast-sk
 * @description <h2><code>toast-sk</code></h2>
 *
 * <p>
 *   Notification toast that pops up from the bottom of the screen when shown.
 *   Note that toast-sk doesn't add anyting inside the toast, it just presents
 *   the existing child elements.
 * </p>
 *
 * @attr duration - The duration, in ms, to display the notification. Defaults
 *               to 5000. A value of 0 means to display forever.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastSk", {
    enumerable: true,
    get: function() {
        return ToastSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ToastSk = class ToastSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        // We use Light DOM and want to preserve existing children (like error-toast-sk's content),
        // so we return noChange to prevent Lit from modifying the child list.
        return _lit.noChange;
    }
    /** Displays the contents of the toast. */ show() {
        this.shown = true;
        if (this.duration > 0 && !this._timer) {
            this._timer = window.setTimeout(()=>{
                this._timer = null;
                this.hide();
            }, this.duration);
        }
    }
    /** Hides the contents of the toast. */ hide() {
        this.shown = false;
        if (this._timer) {
            window.clearTimeout(this._timer);
            this._timer = null;
        }
    }
    constructor(...args){
        super(...args);
        this.duration = 5000;
        this.shown = false;
        this._timer = null;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Number)
], ToastSk.prototype, "duration", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean,
        reflect: true
    }),
    _ts_metadata("design:type", Boolean)
], ToastSk.prototype, "shown", void 0);
ToastSk = _ts_decorate([
    (0, _decorators.customElement)('toast-sk')
], ToastSk);
